export default {
  data: () => ({
    supplier_valuation: [],
    suppliers_inv_total: 0,
    suppliers_inv_page: 1
  }),
  methods: {
    async supplierValuationsGet() {
      const result = this.$communicator.then(this, await this.$communicator('supplier_valuation', {
        query: {
          limit: 10,
          page: this.$store.state.suppValPage,
          service: this.main_store?._id,
          search: this.search
        },
      }))
      if (result && result.data instanceof Array) {
        this.suppliers_inv_total = Math.ceil(result.total / 10)
        this.supplier_valuation = result.data;
        this.max_total = result.total
      }
      else {
        this.supplier_valuation = [];
      }
    }
  }
}
